import {combineReducers} from 'redux';
import {connectRouter} from 'connected-react-router';
import stats from './statsReducer';
import blocks from './blocksReducer';
import workers from './workersReducer';
import nav from './navigationReducer';
import user from './userReducer';
import error from './errorReducer';

const root = history => combineReducers({
    error,
    user,
    stats,
    blocks,
    workers,
    nav,
    router: connectRouter(history),
});

export default root;



// WEBPACK FOOTER //
// /src/redux/reducers/index.js